import { jsxs as P, jsx as t } from "react/jsx-runtime";
import { IconButton as y } from "../../../atoms/Button/Button.es.js";
import { ChevronLeftIcon as z, ChevronRightIcon as F } from "../../../icons/index.es.js";
import "react";
import { chakra as I } from "@chakra-ui/react";
import "../../../atoms/Tooltip/Tooltip.es.js";
import "../../Dropdown/Dropdown.context.es.js";
import "../../Dropdown/components/DropdownItem.es.js";
import "../../Dropdown/Dropdown.container.es.js";
import "../../Select/Select.constants.es.js";
import { S as b } from "../../../SelectOption-a05022b4.js";
import { Select as f } from "../../Select/Select.container.es.js";
import { useDatePickerContext as M, useDatePickerStyle as O } from "../DatePicker.context.es.js";
import { getDateString as k, isValidDate as D } from "../DatePicker.utils.es.js";
const N = () => {
  const { data: a, propGetters: s, minYears: C, maxYears: S, updateDate: u, updateDirty: g, mode: v, offsetDate: o } = M(), x = O(), [{ year: Y, month: B }] = a.calendars;
  return /* @__PURE__ */ P(I.div, { __css: x.header, children: [
    /* @__PURE__ */ t(
      y,
      {
        "aria-label": "Previous month",
        icon: /* @__PURE__ */ t(z, { boxSize: 4 }),
        variant: "transparent",
        size: "md",
        ...s.subtractOffset({ months: 1 })
      }
    ),
    /* @__PURE__ */ t(f, { placeholder: "Month", variant: "borderless", value: B, children: a.months.map((e) => {
      const { disabled: l, onClick: c, ...d } = s.monthButton(e), m = v === "range" ? c : () => {
        const [r] = a.selectedDates, h = (o == null ? void 0 : o.getFullYear()) ?? e.$date.getFullYear(), p = (e.$date.getMonth() ?? 0) + 1, n = r == null ? void 0 : r.getDate(), i = k({ year: h, month: p, day: n }, !0);
        D(i) && (u(i, !!n), g({ month: !0 }));
      };
      return /* @__PURE__ */ t(
        b,
        {
          value: e.month,
          isDisabled: l,
          onClick: m,
          ...d,
          children: e.month
        },
        e.month
      );
    }) }),
    /* @__PURE__ */ t(f, { placeholder: "Year", variant: "borderless", value: Y, children: a.years.filter(({ year: e }) => e >= C && e <= S).reverse().map((e) => {
      const { disabled: l, onClick: c, ...d } = s.yearButton(e), m = v === "range" ? c : () => {
        const [r] = a.selectedDates, h = e.$date.getFullYear(), p = ((o == null ? void 0 : o.getMonth()) ?? 0) + 1, n = r == null ? void 0 : r.getDate(), i = k({ year: h, month: p, day: n }, !0);
        D(i) && (u(i, !!n), g({ year: !0 }));
      };
      return /* @__PURE__ */ t(
        b,
        {
          value: e.year.toString(),
          onClick: m,
          isDisabled: l,
          ...d,
          children: e.year.toString()
        },
        e.year
      );
    }) }),
    /* @__PURE__ */ t(
      y,
      {
        "aria-label": "Previous month",
        icon: /* @__PURE__ */ t(F, { boxSize: 4 }),
        variant: "transparent",
        size: "md",
        ...s.addOffset({ months: 1 })
      }
    )
  ] });
};
export {
  N as DatePickerHeader
};
//# sourceMappingURL=DatePickerHeader.es.js.map
